export const OPERATIONS_CHANGE_NDG = [
    '_SWITR',
    '_SWITC',
    '_VAGG',
    '_RISPA',
    '_RISTO',
    '_SWIT'
]

export const OPERATIONS_WITH_FREQUENCY = [
    '_VPRFR',
    '_RIAPU'
]

export const OPERATIONS_WITH_IBAN = [
    '_VAGG',
    '_VCBMU',
    '_RISPA',
    '_RISTO',
    '_VCONT',
    '_SCOPZ',
    '_VBESC'
]

export const OPERATINS_WITHOUT_CONFIRM_MODAL = [
    '_INPAG',
    '_RIAPU',
    '_ARIST',
    '_ARISP',
    '_ANAPP'
]

export const CANCEL_OPERATIONS = [
    '_ARIST',
    '_ARISP',
    '_ANAPP'
]

export interface IIbanObject {
    codicePaese: string;
    codiceInternazionaleEuropeo: string;
    codiceNazionaleBBAN: string;
    abiRapporto: string;
    cabRapporto: string;
    numeroRapporto: string;
    codiceBIC?: string;
    categoriaRapporto?: string;
    convenzioneRapporto?: string;
    filialeRapporto?: string;
}

export interface IOperationPayment {
    paymentMethod: 'Bonifico' | 'Bonifico Estero',
    // IBAN italiano
    iban?: string;
    accountHolder?: string;
    beneficiaryFiscalCode?: string;

    // IBAN estero
    foreignAccount?: string;
    bic?: string;
    foreignCurrency?: string;
    uic?: string;
    bankAddress?: string;
}

export const mock_frequencies = [
    "Annuale",
    "Bimestrale",
    "Mensile",
    "Quadrimestrale",
    "Semestrale",
    "Trimestrale"
]

export interface IDocument {
    codDoc: string;
    codeInd: string;
    descrizioneDocumento: string;
    isUploaded: boolean
    S3UploadUrl: IS3UploadUrl;
    S3DownloadInfo: IS3DownloadInfo;
    providedFromCompany: boolean;
    isMandatory: boolean;
    downloaded?: boolean;
    userDownloaded: boolean;

    isDownloading?: boolean;
    isDownloaded?: boolean;
}

export interface ICancelDocument {
    contentBuffer: any;
    descrizioneDocumento: string;
    contentType: string;
    isDownloaded: boolean;
    providedFromCompany: boolean;
}

export interface ICancelDocumentResponse {
    contentBuffer?: string;
    contentType?: string;
    state?: string;
    contentLength?: string | number;
}

export interface ICompanyDocumentResponse {
    S3DownloadInfo: IS3DownloadInfo;
}

export interface IS3DownloadInfo {
    downloadUrl: string;
    fileFormat?: string;
    fileName?: string;
    fileSize?: string;
    filePages?: string;
}

export interface IS3UploadUrl {
    url: string;
    fields: IIS3UploadFields;
}

export interface IIS3UploadFields {
    "x-amz-meta-format": string;
    "x-amz-meta-pages": string;
    "x-amz-meta-filename": string;
    "x-amz-meta-size": string;
    "bucket": string;
    "X-Amz-Algorithm": string;
    "X-Amz-Credential": string;
    "X-Amz-Date": string;
    "Policy": string;
    "X-Amz-Signature": string;
    "X-Amz-Security-Token": string;
    "key": string;
}

export enum EOperationStep {
    NDG_VARIATION = 'NDG_VARIATION',
    FIRST_STEP = 'FIRST_STEP',
    ADDITIONAL_STEP = 'ADDITIONAL_STEP',
    QUESTIONNAIRE = 'QUESTIONNAIRE',
    DOWNLOAD_DOC = 'DOWNLOAD_DOC',
    NAVIGATE_POLICY = 'NAVIGATE_POLICY',
    UPLOAD_DOC = 'UPLOAD_DOC'
}

export type TOperationStep = keyof typeof EOperationStep;

export enum EProductType {
    BMR740 = 'BMR740',
    BMR744 = 'BMR744',
    BPU750 = 'BPU750',
    BPU720 = 'BPU720',
    BPU725 = 'BPU725',
    BMRU01 = 'BMRU01',
    BMRR01 = 'BMRR01'
}

export const MULTISOLUTION_PRODUCTS = [
    EProductType.BMR740,
    EProductType.BMR744
]

export const UNIT_PRODUCTS = [
    EProductType.BPU750,
    EProductType.BPU720,
    EProductType.BPU725
]

export const MULTISTRATEGY_PRODUCTS = [
    EProductType.BMRU01,
    EProductType.BMRR01
]

export const ALL_PRODUCTS_WITH_FUNDS: string[] = [
    ...MULTISOLUTION_PRODUCTS,
    ...UNIT_PRODUCTS,
    ...MULTISTRATEGY_PRODUCTS
]

export interface ISwitchRamiRequest {
    policyNumber: string;
    allocazioneRami: string;
}

export interface ISwitchRequest {
    policyNumber: string;
    lifeInvestments: ILifeFund[];
    lifeDisinvestments: ILifeFund[];
    ndgTutoreODelegato?: string;
    codiceLineaCompagnia?: string[];
    controvaloreLineaCompagnia?: string[];
    consultancyAmount?: string;
}

export interface ILifeFund {
    fundCode: string;
    percentage?: string;
    fundAmount?: string;
}

export const MIN_VAGG_AMOUNT_FOR_QUESTIONNAIRE: number = 5000;

export enum ERedeemPrefixCode {
    _RISPA = 'RP',
    _RISTO = 'RT'
}

export interface ICheckConsultancyResponse {
    consultancy: boolean;
    body: IDatiMifid;
}

export interface IDatiMifid {
    // TODO
}

export const ERR_DOC_RETRIEVE_MESSAGE: string = 'Errore nel recupero dei documenti da scaricare';
export const ERROR_DOWNLOADING_DOC_MESSAGE: string = 'Errore durante il download del documento';
export const COD_COLLEGAMENTI_ATTIVI_AMMESSI: string[] = ['102', '103', '104', '105', '107', '108', '109', '111', '112', '115', '116', '118', '122', '134', '135', '137', '142','143', '149', '155', '157', '159', '160', '176', '180', '187']

export const QUESTION_CODES_WITH_ANAGRAFICA_REQUEST: string[] = ['FATIT1', 'FATIT2', 'FATIT3', 'FATIT4']
